import React, { FC, useState } from 'react';
import './switchTabs.scss'
interface SwitchTabsProps {
    tabs: string[],
    defaultSelected: number,
    onSelect: (index: number) => void
}
export const SwitchTabs:FC<SwitchTabsProps> = ({tabs, defaultSelected, onSelect}) => {
    const [selected, setSelected] = useState(defaultSelected)
    return (
        <div className="switch__wrapper">
        {
            tabs?.map((value, index) => {
                return(
                    <div
                    className={`switch__item ${
                      selected == index && "selected"
                    }`}
                    onClick={() => {
                      setSelected(index);
                      onSelect(index)
                    }}
                  >
                    {value}
                  </div>
                )
            })
        }
       
       
      </div>
    )
}